module.exports = "../fonts/HelveticaNeueLTW01-35Thin.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/main/script/komodo/fonts/HelveticaNeueLTW01-35Thin.woff2
// module id = 3FiO
// module chunks = 1